window.LazyLoad = require('vanilla-lazyload');

window.onload = function () {
  // var firstBrochureImage = $('.brochure > img').eq(0);
  //
  // if (firstBrochureImage.length > 0) {
  //   var brochureImageHeight = firstBrochureImage[0].height;
  //   var brochureImageWidth = firstBrochureImage[0].width;
  //
  //   $('.brochure > img.lazy').each(function () {
  //     $(this).height(brochureImageHeight);
  //     $(this).width(brochureImageWidth);
  //     $(this).css('background-color', '#f2f2f2');
  //     $(this).css('display', 'block');
  //   });
  // }

  //lazy loading for images
  window.LazyLoad = new LazyLoad({
    elements_selector: "img.lazy",
    // When the .lazy div enters the viewport...
    callback_enter: function(el) {}
  });
};
